// extracted by mini-css-extract-plugin
module.exports = {"dismissWrapper":"DismissButton_dismissWrapper__xyGxq","dismissContainer":"DismissButton_dismissContainer__mLyY6","dismiss":"DismissButton_dismiss__vV7GT"};